export default __webpack_public_path__ + "static/media/tips.4d16cb95.png";